import * as R from 'ramda';
import { memoizeOneFactory } from 'core/memoizer';
import { getFilterCellStyle, getFilterOpCellStyle } from '../style';
import { traverseMap2 } from 'core/math/matrixZipMap';
const getter = (columns, filterStyles) => R.map(column => getFilterCellStyle(column)(filterStyles), columns);
const opGetter = (rows, columns, columnStyles) => traverseMap2(R.range(0, rows), R.range(0, columns), () => getFilterOpCellStyle()(columnStyles));
export default memoizeOneFactory(getter);
export const derivedFilterOpStyles = memoizeOneFactory(opGetter);
